export default "__VITE_ASSET__DHBAW5Qz__"